module.exports = __webpack_public_path__ + "static/media/edna23.99f91564.png";